export default {
    overlayIsVisible: state => {
        return state.overlay.isVisible;
    },
    overlayGetPages: state => {
        return state.overlay.pages;
    },
    overlayGetCurrentPage: state => {
        return state.overlay.pages[state.overlay.currentPageIndex];
    },
    overlayHasNextPage: state => {
        return state.overlay.pages.length - 1 > state.currentPageIndex;
    },
    overlayHasPreviousPage: state => {
        return state.overlay.currentPageIndex > 0;
    },
    overlayGetCurrentPageIndex: state => {
        return state.overlay.currentPageIndex;
    },
    overlayGetNavDirection: state => {
        return state.overlay.navDirection;
    },

};